var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "App Icon/DriveFlex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Icon/DriveFlex",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    transform: "translate(24.000000, 24.000000) rotate(-270.000000) translate(-24.000000, -24.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#159BD7",
    x: 25.2,
    y: 29.6,
    width: 22.8,
    height: 18.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5",
    fill: "#025EB5",
    points: "36.4 0 48 0 48 36.8 29.7873518 29.431708"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#025EB5",
    points: "6 20.4 32.9636475 29.1258789 25.2402344 48 6 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    fill: "#003292",
    points: "0 16.4 16.8349609 22.9186523 6.8 48 0 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    fill: "#003999",
    points: "16.4 0 44.8 0 32.4063477 30.4924805 16.4 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#001F7B",
    points: "0 0 26.4 0 16.4024048 24 0 17.4896356"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Right-Bar",
    fill: "#82C600",
    x: 44,
    y: 0,
    width: 4,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3953125,23.028125 L7.140625,23.028125 L7.140625,27.6 L4.6140625,27.6 L4.6140625,15.0875 L8.64453125,15.0875 C9.91068341,15.0875 10.8889288,15.4154915 11.5792969,16.0714844 C12.2696649,16.7274772 12.6148437,17.6598898 12.6148437,18.86875 C12.6148437,20.5302166 12.0104227,21.6932258 10.8015625,22.3578125 L12.9929687,27.4796875 L12.9929687,27.6 L10.2773438,27.6 L8.3953125,23.028125 Z M7.140625,20.9226563 L8.57578125,20.9226563 C9.07995044,20.9226563 9.45807166,20.7550798 9.71015625,20.4199219 C9.96224084,20.0847639 10.0882813,19.6364611 10.0882813,19.075 C10.0882813,17.8203062 9.5984424,17.1929687 8.61875,17.1929687 L7.140625,17.1929687 L7.140625,20.9226563 Z M20.3234375,25.0390625 L16.8773438,25.0390625 L16.2070313,27.6 L13.534375,27.6 L17.4445313,15.0875 L19.75625,15.0875 L23.6921875,27.6 L20.99375,27.6 L20.3234375,25.0390625 Z M17.4273438,22.9335938 L19.7648438,22.9335938 L18.5960938,18.4734375 L17.4273438,22.9335938 Z M13.0875,38.2320313 C13.0244789,39.6586009 12.6234412,40.738538 11.884375,41.471875 C11.1453088,42.205212 10.1026109,42.571875 8.75625,42.571875 C7.34113876,42.571875 6.25690481,42.1063849 5.50351563,41.1753906 C4.75012644,40.2443964 4.3734375,38.9166753 4.3734375,37.1921875 L4.3734375,35.0867188 C4.3734375,33.3679602 4.76301694,32.0431036 5.5421875,31.1121094 C6.32135806,30.1811151 7.40415973,29.715625 8.790625,29.715625 C10.1541735,29.715625 11.18971,30.0966108 11.8972656,30.8585938 C12.6048212,31.6205767 13.0072912,32.7148366 13.1046875,34.1414063 L10.5695313,34.1414063 C10.5466145,33.2591102 10.4105481,32.6503923 10.1613281,32.3152344 C9.91210813,31.9800764 9.45521166,31.8125 8.790625,31.8125 C8.11457995,31.8125 7.63619932,32.0488258 7.35546875,32.5214844 C7.07473818,32.994143 6.92578134,33.7718696 6.90859375,34.8546875 L6.90859375,37.2179688 C6.90859375,38.4612041 7.04752465,39.3148414 7.32539063,39.7789063 C7.6032566,40.2429711 8.08020495,40.475 8.75625,40.475 C9.42083666,40.475 9.87916541,40.3131527 10.13125,39.9894531 C10.3833346,39.6657536 10.5265623,39.0799522 10.5609375,38.2320313 L13.0875,38.2320313 Z M21.1054688,36.9859375 L17.1695313,36.9859375 L17.1695313,40.303125 L21.8273438,40.303125 L21.8273438,42.4 L14.6429688,42.4 L14.6429688,29.8875 L21.8101563,29.8875 L21.8101563,31.9929688 L17.1695313,31.9929688 L17.1695313,34.9492188 L21.1054688,34.9492188 L21.1054688,36.9859375 Z",
    id: "RA-CE",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRace);
export default __webpack_public_path__ + "static/media/race.262c095f873875ea1fb91094b28e7e4b.svg";
export { ForwardRef as ReactComponent };